'use client'
import { useSession, signIn, signOut, SessionProvider } from "next-auth/react"
import { type ReactNode, Suspense } from "react"
import { AuthProvider } from "./AuthProvider"

export function SessionAuthProvider({ children }: { children: ReactNode }) {
  return (
    <SessionProvider refetchOnWindowFocus={false}>
      <Suspense>
        <AuthProvider>
          {children}
        </AuthProvider>
      </Suspense>
    </SessionProvider>
  )
}